import React, { useEffect } from 'react';
import { BookOpen } from 'lucide-react';

const SoroBlog = () => {
  useEffect(() => {
    // Load SORO script if not already loaded
    const scriptId = 'soro-embed-script';
    
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://app.trysoro.com/api/embed/0d674ee6-5198-4da0-8a49-88c0647d21c4';
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-amber-100/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <BookOpen className="h-4 w-4" />
            Blog
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            Actualités & 
            <span className="bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent"> Conseils</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez nos derniers articles, conseils et actualités sur la photographie et vidéographie événementielle.
          </p>
        </div>

        {/* SORO Blog Embed Container */}
        <div id="soro-blog" className="max-w-7xl mx-auto"></div>
      </div>
    </section>
  );
};

export default SoroBlog;
